import { List, useTable, EditButton, ShowButton, DeleteButton, CreateButton } from '@refinedev/antd'
import { Table, Tag, Space, Typography, Input } from 'antd'
import dayjs from 'dayjs'
import { STATUS_META, type BlogPostStatus } from './utils'

const { Text } = Typography

interface BlogPostRow {
  id: string
  titleSr: string
  slugSr: string
  category: string | null
  status: BlogPostStatus
  publishedAt: string | null
  updatedAt: string
}

export function BlogListPage() {
  const { tableProps, setFilters } = useTable<BlogPostRow>({
    resource: 'blog',
    syncWithLocation: true,
    sorters: { initial: [{ field: 'updatedAt', order: 'desc' }] },
  })

  return (
    <List headerButtons={<CreateButton />}>
      <Input.Search
        placeholder="Pretraga po naslovu…"
        allowClear
        style={{ maxWidth: 320, marginBottom: 16 }}
        onSearch={(value) =>
          setFilters([{ field: 'search', operator: 'contains', value: value || undefined }])
        }
      />
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="titleSr"
          title="Naslov"
          render={(value: string, record: BlogPostRow) => (
            <Space direction="vertical" size={0}>
              <Text strong>{value}</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                /{record.slugSr}
              </Text>
            </Space>
          )}
        />
        <Table.Column
          dataIndex="status"
          title="Status"
          render={(value: BlogPostStatus) => {
            const meta = STATUS_META[value] ?? STATUS_META.DRAFT
            return <Tag color={meta.color}>{meta.label}</Tag>
          }}
        />
        <Table.Column
          dataIndex="category"
          title="Kategorija"
          render={(value: string | null) => value || <Text type="secondary">—</Text>}
        />
        <Table.Column
          dataIndex="updatedAt"
          title="Izmenjeno"
          render={(value: string) => dayjs(value).format('DD.MM.YYYY HH:mm')}
        />
        <Table.Column
          title="Akcije"
          dataIndex="actions"
          render={(_, record: BlogPostRow) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <ShowButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  )
}

export default BlogListPage
